/**
 * 预算对比组件
 */
import React from 'react';
import { Typography, Progress, Card, Space, Tag } from 'antd';
import type { ProjectOverviewData } from '../../services/dashboardService';
import { calculateBudgetHealth, formatMoney, getBudgetTagColor } from '../../utils/budgetUtils';

const { Text, Title } = Typography;

interface BudgetComparisonProps {
  project: ProjectOverviewData;
  isMobile?: boolean;
}

const BudgetComparison: React.FC<BudgetComparisonProps> = ({
  project,
  isMobile = false
}) => {
  const budgetHealth = calculateBudgetHealth(project.budget, project.actualCost);

  return (
    <div style={{ marginBottom: isMobile ? 16 : 24 }}>
      <Title level={5} style={{ marginBottom: 16, fontSize: isMobile ? 14 : 16 }}>
        预算对比
      </Title>
      
      <Card
        size="small"
        style={{
          backgroundColor: '#fafafa',
          borderRadius: 8
        }}
        bodyStyle={{ padding: isMobile ? 12 : 16 }}
      >
        {/* 预算数值 */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 8,
          marginBottom: 12
        }}>
          <div>
            <Text type="secondary" style={{ fontSize: 12 }}>预算总额</Text>
            <div>
              <Text strong style={{ fontSize: isMobile ? 16 : 18 }}>
                {formatMoney(project.budget, false)}
              </Text>
            </div>
          </div>
          <div>
            <Text type="secondary" style={{ fontSize: 12 }}>已使用</Text>
            <div>
              <Text strong style={{ fontSize: isMobile ? 16 : 18, color: budgetHealth.color }}>
                {formatMoney(project.actualCost, false)}
              </Text>
            </div>
          </div>
          <div>
            <Text type="secondary" style={{ fontSize: 12 }}>剩余预算</Text>
            <div>
              <Text 
                strong 
                style={{ 
                  fontSize: isMobile ? 16 : 18,
                  color: budgetHealth.remaining >= 0 ? '#52c41a' : '#f5222d'
                }}
              >
                {budgetHealth.remaining >= 0 ? '' : '-'}
                {formatMoney(Math.abs(budgetHealth.remaining), false)}
              </Text>
            </div>
          </div>
        </div>

        {/* 进度条 */}
        <Progress
          percent={Math.min(budgetHealth.percentage, 100)}
          strokeColor={budgetHealth.color}
          trailColor="#e8e8e8"
          format={() => `${budgetHealth.percentage.toFixed(1)}%`}
          style={{ marginBottom: 12 }}
        />

        {/* 状态提示 */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Text style={{ fontSize: isMobile ? 12 : 14 }}>状态:</Text>
          <Tag color={getBudgetTagColor(budgetHealth.status)}>
            {budgetHealth.icon} {budgetHealth.label}
          </Tag>
        </div>
        <Text type="secondary" style={{ fontSize: isMobile ? 11 : 12, display: 'block', marginTop: 4 }}>
          {budgetHealth.message}
        </Text>
      </Card>
    </div>
  );
};

export default BudgetComparison;
